import { put, call, takeLatest, select } from 'redux-saga/effects';

import { nudgeApproval } from 'services/story-editor';
import { AsyncAction } from 'types/Action';
import { NudgeApprovalMeta, NudgeApprovalPayload } from 'types/store/NudgeApproval';
import { Store } from 'types/store/Store';

import { nudgeApprovalActions } from '../actions';

function* nudgeApprovalRequest(action: AsyncAction<NudgeApprovalMeta, NudgeApprovalPayload>): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const {data}  = yield call(nudgeApproval, action.meta, state.auth.token);
      yield put(nudgeApprovalActions.success(data));
    } catch (e: any) {
      yield put(nudgeApprovalActions.failed(e.message));
    }
  }
}

// function* nudgeApprovalSuccess(action: AsyncAction<NudgeApprovalMeta, NudgeApprovalPayload>): any {
//   yield put()
// }

function* nudgeApprovalWatcher(): any {
  yield takeLatest(nudgeApprovalActions.REQUEST, nudgeApprovalRequest);
  // yield takeLatest(nudgeApprovalActions.SUCCESS, nudgeApprovalSuccess);
}

export default nudgeApprovalWatcher;
